import { useTranslation } from 'react-i18next';

import { assetUrl } from '../../common/helpers';
import UI from '../../common/UI';
import useProject from '../useProject';

const NoEventsCard = () => {
  const { t } = useTranslation();
  const project = useProject();

  return (
    <UI.Section sc={{ compact: true, mt: { md: 8 } }}>
      <UI.Card sc={{ padding: 8, textAlign: 'center', background: 'gray.50' }} style={{ textWrap: 'balance' }}>
        <img src={assetUrl('images/participant.svg')} alt="" height={120} />
        <UI.H3 sc={{ mb: 2 }}>{t('no_events_yet')}</UI.H3>
        <UI.Paragraph>{t('get_started_by_creating_event')}</UI.Paragraph>
        <UI.NavButton to={`/${project.id}/events/add`} sc={{ brand: 'secondary' }}>
          {t('create_an_event')}
        </UI.NavButton>
      </UI.Card>
    </UI.Section>
  );
};

export default NoEventsCard;
